// Fired on window whenever something this app did may have changed the signed-in user's notifications —
// one marked read, all marked read, a push arriving in the foreground — so the bell refetches its count
// at once instead of on its next poll. Carries no detail: listeners re-read the summary.
export const NOTIFICATIONS_CHANGED_EVENT = 'notifications:changed';

export function emitNotificationsChanged(): void {
  window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
}

// Whether a notification's route is a path inside this app, and so safe to hand to navigate(). A route
// arrives from the server and from push payloads, which the app does not control end to end, so anything
// that could leave the origin is refused: a protocol-relative "//host", and a backslash, which browsers
// read as a slash ("/\host" resolves to another origin).
export function isSafeRoute(route: unknown): route is string {
  return (
    typeof route === 'string' &&
    route.startsWith('/') &&
    !route.startsWith('//') &&
    !route.includes('\\')
  );
}
